module.exports = __webpack_public_path__ + "static/img/gnmk_3@2x.b74b6411.png";